import { SettingsService, } from "@inter-ikea-kompis/services";
import { getLocalization } from "./utils/helpers";
import { getDexfApiKey } from "./utils/dexf";
import { Segment } from "./Fetch";
import { DexfSettingsEnvironmentEnum } from "@inter-ikea-kompis/enums";
import { findSubPlanner } from "./Planners";
export const getDexfSettingsService = (appId, segment) => {
    const prod = segment === Segment.production;
    const env = prod
        ? DexfSettingsEnvironmentEnum.production
        : DexfSettingsEnvironmentEnum.development;
    return new SettingsService(getServiceSettingsOptions(appId, prod, env)).getApplicationSettings();
};
export const getServiceSettingsOptions = (appId, prod, env) => ({
    dexfApiKey: getDexfApiKey(appId, prod),
    dexfEnvironment: env,
    dexfApplicationId: appId,
    locale: getLocalization(),
});
export const getTranslationSettings = (range) => ({
    locale: getLocalization(),
    translationEndpoints: [
        "/addon-app/translations/kompis/en-XZ.json",
        "/addon-app/translations/kompis/{language}-{country}.json",
        `/addon-app/${findSubPlanner(range)}/translations/en-XZ.json`,
        `/addon-app/${findSubPlanner(range)}/translations/{language}-{country}.json`,
    ],
});
